function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 120,
  rx: 60,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.7306 52.2666C95.0839 52.2666 94.5569 51.7395 94.5569 51.0928C94.5569 50.4461 95.0839 49.9234 95.7306 49.9234H97.5202C98.0339 49.9234 98.5078 49.7109 98.8489 49.3698C99.19 49.0287 99.4025 48.5548 99.4025 48.0411V34.8864C99.4025 34.2398 99.9252 33.7126 100.576 33.7126C101.223 33.7126 101.745 34.2398 101.745 34.8864V48.0411C101.745 49.2016 101.272 50.2601 100.505 51.0264C99.7392 51.7926 98.6852 52.2666 97.5203 52.2666H95.7306Z",
  fill: "#017297"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M90.2606 39.5328H93.3877C94.6766 39.5328 95.7306 40.5869 95.7306 41.8758V60.3145C95.7306 61.6034 94.6766 62.6575 93.3877 62.6575H90.2606V39.5328Z",
  fill: "#024C67"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.576 35.6661C102.463 35.6661 104 34.1292 104 32.2423C104 30.3511 102.463 28.8142 100.576 28.8142C98.6852 28.8142 97.148 30.3512 97.148 32.2423C97.148 34.1291 98.685 35.6661 100.576 35.6661Z",
  fill: "#FF6471"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.303 74.8644H66.7417V88.1077H48.303V74.8644Z",
  fill: "#017297"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.127 28.4375H87.9178C89.6363 28.4375 91.0448 29.8461 91.0448 31.5645V34.8466L89.468 51.4294L91.0448 67.3434V72.9688C91.0448 74.6872 89.6363 76.0958 87.9178 76.0958H27.127C25.4086 76.0956 24 74.6872 24 72.9688V67.3436L25.5725 51.4295L24 34.8467V31.5647C24 29.8461 25.4086 28.4375 27.127 28.4375Z",
  fill: "#025F80"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.1381 28.4375H87.9177C89.6361 28.4375 91.0447 29.8461 91.0447 31.5645V34.8466L89.4678 51.4294L91.0447 67.3434V72.9688C91.0447 74.6872 89.6361 76.0958 87.9177 76.0958H27.127C25.4086 76.0956 24 74.6872 24 72.9688V72.1892H83.2314C85.3797 72.1892 87.1381 70.4308 87.1381 68.2827V28.4375Z",
  fill: "#024C67"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 34.8467H91.0447V67.3436H24V34.8467Z",
  fill: "#B3DAFE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.67 34.8467H41.7789V67.3436H34.67V34.8467Z",
  fill: "#3EC3A4"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M53.968 34.8467H61.0767V67.3436H53.968V34.8467Z",
  fill: "#3EC3A4"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.2614 34.8467H80.3747V67.3436H73.2614V34.8467Z",
  fill: "#3EC3A4"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5616 40.7817H43.887C44.578 40.7817 45.1405 41.3442 45.1405 42.0308V60.155C45.1405 60.8459 44.578 61.4084 43.887 61.4084H32.5616C31.8706 61.4084 31.3081 60.8459 31.3081 60.155V42.0308C31.3081 41.3442 31.8708 40.7817 32.5616 40.7817Z",
  fill: "#FF6471"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M51.8595 40.7817H63.185C63.8716 40.7817 64.4341 41.3442 64.4341 42.0308V60.155C64.4341 60.8459 63.8714 61.4084 63.185 61.4084H51.8595C51.1686 61.4084 50.6061 60.8459 50.6061 60.155V42.0308C50.6061 41.3442 51.1686 40.7817 51.8595 40.7817Z",
  fill: "#FF6471"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.1531 40.7817H82.483C83.1695 40.7817 83.7319 41.3442 83.7319 42.0308V60.155C83.7319 60.8459 83.1694 61.4084 82.483 61.4084H71.1531C70.4666 61.4084 69.9041 60.8459 69.9041 60.155V42.0308C69.9041 41.3442 70.4667 40.7817 71.1531 40.7817Z",
  fill: "#FF6471"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M79.8255 40.7817H82.483C83.1695 40.7817 83.7319 41.3442 83.7319 42.0308V60.155C83.7319 60.8459 83.1694 61.4084 82.483 61.4084H71.1531C70.4666 61.4084 69.9041 60.8459 69.9041 60.155V57.502H77.4825C78.7712 57.502 79.8255 56.4478 79.8255 55.1589V40.7817Z",
  fill: "#FF4255"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.5275 40.7817H63.185C63.8716 40.7817 64.4341 41.3442 64.4341 42.0308V60.155C64.4341 60.8459 63.8714 61.4084 63.185 61.4084H51.8595C51.1686 61.4084 50.6061 60.8459 50.6061 60.155V57.502H58.1845C59.4734 57.502 60.5275 56.4478 60.5275 55.1589V40.7817Z",
  fill: "#FF4255"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.2341 40.7817H43.887C44.578 40.7817 45.1405 41.3442 45.1405 42.0308V60.155C45.1405 60.8459 44.578 61.4084 43.887 61.4084H32.5616C31.8706 61.4084 31.3081 60.8459 31.3081 60.155V57.502H38.8864C40.1753 57.502 41.2339 56.4478 41.2339 55.1589L41.2341 40.7817Z",
  fill: "#FF4255"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1449 48.4841C35.4983 48.4841 34.9711 47.9614 34.9711 47.3148C34.9711 46.6681 35.4983 46.1411 36.1449 46.1411H40.3039C40.9506 46.1411 41.4777 46.6683 41.4777 47.3148C41.4777 47.5053 41.4289 47.6825 41.3492 47.8419L38.0494 55.3494C37.7925 55.9384 37.1016 56.2086 36.5081 55.9473C35.9189 55.6861 35.6488 54.9951 35.9102 54.4059L38.5102 48.4841H36.1449Z",
  fill: "#FFE363"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4428 48.4841C54.7962 48.4841 54.2691 47.9614 54.2691 47.3148C54.2691 46.6681 54.7962 46.1411 55.4428 46.1411H59.6017C60.2484 46.1411 60.7755 46.6683 60.7755 47.3148C60.7755 47.5053 60.7269 47.6825 60.6472 47.8419L57.3473 55.3494C57.0859 55.9384 56.3995 56.2086 55.8059 55.9473C55.2125 55.6861 54.9467 54.9951 55.208 54.4059L57.8078 48.4841H55.4428Z",
  fill: "#FFE363"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M74.7364 48.4841C74.0897 48.4841 73.5672 47.9614 73.5672 47.3148C73.5672 46.6681 74.0899 46.1411 74.7364 46.1411H78.8999C79.5466 46.1411 80.0691 46.6683 80.0691 47.3148C80.0691 47.5053 80.0249 47.6825 79.945 47.8419L76.6455 55.3494C76.3841 55.9384 75.6931 56.2086 75.1041 55.9473C74.5105 55.6861 74.2449 54.9951 74.5017 54.4059L77.1061 48.4841H74.7364Z",
  fill: "#FFE363"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.1572 86.8763H70.8875C72.1764 86.8763 73.2305 87.9305 73.2305 89.2192C73.2305 90.5083 72.1764 91.5623 70.8875 91.5623H44.1572C42.8683 91.5623 41.8142 90.5081 41.8142 89.2192C41.8142 87.9305 42.8683 86.8763 44.1572 86.8763Z",
  fill: "#024C67"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M56.2711 72.9687C55.5802 72.9687 55.0222 72.4106 55.0222 71.7197C55.0222 71.0287 55.5802 70.4706 56.2711 70.4706H58.7736C59.4602 70.4706 60.0227 71.0286 60.0227 71.7197C60.0227 72.4106 59.4602 72.9687 58.7736 72.9687H56.2711Z",
  fill: "#BBF49B"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.492 82.9697H48.303V86.8762H66.7417V76.0956H62.8352V80.6267C62.8352 81.9156 61.7811 82.9697 60.492 82.9697Z",
  fill: "#025F80"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M87.1381 34.8467H91.0447V67.3436H87.1381V34.8467Z",
  fill: "#8AC9FE"
});

const SvgProvider2 = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProvider2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/provider2.89682c55.svg";
export { ForwardRef as ReactComponent };